module.exports = __webpack_public_path__ + "files/3eadbc847832687097596047c4d858e2.svg";